import * as React from 'react';

import { DataTable, Table } from '../components/common';
import { IconButton } from '../components/buttons';
import { IconDelete, IconEdit } from '../components/icons';
import Utils from '../common/utils';

interface Props {
	beneficiaries: CustomerPolicyBeneficiaryDto[];
	onEdit: (row?: any) => void;
	onDelete: (row?: any) => void;
	loading: boolean;
	readOnly: boolean;
}
const PolicyBeneficiariesList = (props: Props) => {
	return (
		<DataTable
			TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
			columns={[
				{
					accessor: 'id',
					show: false
				},
				{
					Header: 'First Name',
					accessor: 'firstName'
				},
				{
					Header: 'Last Name',
					accessor: 'lastName'
				},
				{
					Header: 'Policy #',
					accessor: 'policy.number'
				},
				{
					Header: 'Type',
					accessor: 'typeId',
					Cell: (row: any) => Utils.getPickListItemDescription(row.value)
				},
				{
					Header: 'Disbursement',
					accessor: 'disbursementPercent',
					Cell: (row: any) => Math.trunc(row.value * 100).toString() + ' %'
				},
				{
					Header: 'Status',
					accessor: 'statusId',
					Cell: (row: any) => Utils.getPickListItemDescription(row.value)
				},
				{
					Header: 'Actions',
					className: 'p-0 td-actions',
					width: 120,					
					Cell: (rowInfo: any) => (
						<span>
							<IconButton
								onClick={(e: any) => {
									e.stopPropagation(); // Prevent onClick conflict with tr onclick
									props.onEdit(rowInfo.original);
								}}
								title="Edit beneficiary"
								className="btn-icon-secondary btn-icon-td"
								disabled={props.readOnly}
							>
								<IconEdit />
							</IconButton>
							<IconButton
								onClick={(e: any) => {
									e.stopPropagation(); // Prevent onClick conflict with tr onclick
									props.onDelete(rowInfo.original);
								}}
								title="Delete beneficiary"
								className="btn-icon-secondary btn-icon-td"
								disabled={props.readOnly}
							>
								<IconDelete />
							</IconButton>
						</span>
					)
				}
			]}
			data={props.beneficiaries}
			getTrProps={(state: any, rowInfo: any, column: any) => {
				return { className: 'tr interactive', onClick: () => !props.readOnly && props.onEdit(rowInfo.original) };
			}}
			noDataText="No policy beneficiaries found"
			showPagination={false}
			loading={props.loading}
		/>
	);
};
export default PolicyBeneficiariesList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/policy/PolicyBeneficiariesList.tsx